export function normalizeRussianPhoneDigits(value) {
  let digits = String(value || '').replace(/\D/g, '')

  if (!digits) return ''
  if (digits[0] === '8') digits = `7${digits.slice(1)}`
  else if (digits[0] !== '7') digits = `7${digits}`

  return digits.slice(0, 11)
}

export function formatRussianPhone(value) {
  const digits = normalizeRussianPhoneDigits(value)
  if (!digits) return ''

  const local = digits.slice(1)
  let result = '+7'

  if (local.length) result += ` (${local.slice(0, 3)}`
  if (local.length >= 3) result += ')'
  if (local.length > 3) result += ` ${local.slice(3, 6)}`
  if (local.length > 6) result += `-${local.slice(6, 8)}`
  if (local.length > 8) result += `-${local.slice(8, 10)}`

  return result
}

export function installPhoneMaskDirective(Vue) {
  Vue.directive('phone-mask', {
    inserted(el) {
      const applyMask = () => {
        const formatted = formatRussianPhone(el.value)
        if (el.value === formatted) return
        el.value = formatted
        el.dispatchEvent(new Event('input', { bubbles: true }))
      }

      const onFocus = () => {
        if (!el.value) {
          el.value = '+7'
          el.dispatchEvent(new Event('input', { bubbles: true }))
        }
      }

      const onBlur = () => {
        if (normalizeRussianPhoneDigits(el.value).length <= 1) {
          el.value = ''
          el.dispatchEvent(new Event('input', { bubbles: true }))
        }
      }

      el.__russianPhoneMaskHandlers = { applyMask, onFocus, onBlur }
      el.setAttribute('inputmode', 'tel')
      el.setAttribute('autocomplete', el.getAttribute('autocomplete') || 'tel')
      el.setAttribute('maxlength', '18')
      el.addEventListener('input', applyMask)
      el.addEventListener('focus', onFocus)
      el.addEventListener('blur', onBlur)
      applyMask()
    },
    unbind(el) {
      const handlers = el.__russianPhoneMaskHandlers
      if (!handlers) return
      el.removeEventListener('input', handlers.applyMask)
      el.removeEventListener('focus', handlers.onFocus)
      el.removeEventListener('blur', handlers.onBlur)
      delete el.__russianPhoneMaskHandlers
    }
  })
}
